export const imageMixin = {
    methods: {
        strTo64Base(text){
            let width = 0;
            let height = 0;
            let fontSize = 20;
            let lineHeight = 5;
            let font = fontSize + "px 'Noto Sans JP', sans-serif";
            // 文字列を改行で分割
            let splitedText = text != null ? text.split('\n'):[];
            // 半角・全角それぞれでテキスト幅を加算していく
            let textRowWidthList = [];
            let graphemesplit = require("graphemesplit")
            splitedText.forEach((str) => {
                let text = str ? graphemesplit(str) : [];
                let length = text.length
                textRowWidthList.push(length);
            });
            let maxRowWidth = textRowWidthList.reduce(function (a, b) {
                return Math.max(a, b)
            }, 0);
            // 最大のテキスト幅に合わせて、テキストエリアの幅を変える
            width = maxRowWidth * fontSize + 25;
             // 行数に合わせて、テキストエリアの高さを変える
            height = splitedText.length * (fontSize + lineHeight);
            
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            let context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
            let x = 1;
            let y = fontSize;
            context.font = font;
            splitedText.forEach((str) => {
                context.fillText(str, x, y);
                y = y + fontSize + lineHeight;
            });
            context.restore();
            
            return canvas.toDataURL("image/png",1.0);
        },
    }
} 
